import { useState, useEffect } from 'react';
import { Button, IconButton, Modal, TextField } from '@hevoio/hevo-ui-toolkit';
import { IWorkspace } from '../../../../interfaces/workspace';
import styles from './DeleteWorkspaceModal.module.scss';
import { IconTrash, IconX } from '@tabler/icons-react';

interface DeleteWorkspaceModalProps {
  workspace: IWorkspace | null;
  deleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function DeleteWorkspaceModal({
  workspace,
  deleting,
  onConfirm,
  onClose
}: DeleteWorkspaceModalProps) {
  const [confirmName, setConfirmName] = useState('');

  useEffect(() => {
    if (!workspace) setConfirmName('');
  }, [workspace]);

  const nameMatches = !!workspace && confirmName === workspace.name;

  return (
    <Modal open={!!workspace} onClose={onClose} contentClassName={styles.modalContent}>
      <div className={styles.modal}>
        <div className='dialog-header'>
          <div className={styles.headerContent}>
            <div className={styles.headerIcon}>
              <IconTrash size={24} />
            </div>
            <span className={styles.headerTitle}>Delete <strong>{workspace?.name}</strong>?</span>
          </div>
          <IconButton onClick={onClose} disabled={deleting} dataId='delete-workspace-modal-close' label='Close'>
            <IconX size={20} />
          </IconButton>
        </div>

        <div className='dialog-body'>
          <p className={styles.description}>
            All Pipelines, Destinations, and users in Workspace <strong>{workspace?.name}</strong> will be permanently deleted. This action cannot be undone.
          </p>

          <div className={styles.confirmField}>
            <div className={styles.confirmLabelRow}>
              <span className={styles.confirmLabel}>Enter Workspace Name</span>
              <span className={styles.required}>*</span>
            </div>
            <TextField
              dataId='delete-workspace-name-confirm'
              value={confirmName}
              onChange={e => setConfirmName((e.target as HTMLInputElement).value)}
              placeholder={workspace?.name ?? ''}
              disabled={deleting}
              size='small'
              autoFocus
            />
          </div>
        </div>

        <div className='dialog-footer'>
          <Button
            className={styles.actionBtn}
            style={{ width: 70, minWidth: 70 }}
            variation='outline'
            onClick={onClose}
            disabled={deleting}
            dataId='delete-workspace-cancel'
          >
            Cancel
          </Button>
          <Button
            className={`btn-error ${styles.actionBtn}`}
            style={{ width: 99 }}
            onClick={onConfirm}
            showProgress={deleting}
            disabled={deleting || !nameMatches}
            dataId='delete-workspace-confirm'
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
